import { colors } from '../themes/lightTheme';

export const IMPACT_LEVEL_COLORS = {
    minor: colors.warning500,
    moderate: colors.warning600,
    serious: colors.danger600,
    critical: colors.danger700,
};